import { render, staticRenderFns } from "./AutoDeadline.vue?vue&type=template&id=52da3bbf&"
import script from "./AutoDeadline.vue?vue&type=script&lang=js&"
export * from "./AutoDeadline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports